import api from '@/apis/di/fixedAssetCategoryAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';
import {getCurrentInstance} from 'vue';

// Combo grid Loại khách hàng nhà cung cấp
export const useFixedAssetCategoryComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const {proxy} = getCurrentInstance();
  const {extendFilter} = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onFixedAssetCategoryComboboxLoadData = (payload, row, column, custom) => {
    payload.sort = 'misa_code_id';
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [{Field: 'inactive', Value: false, Ors: ors}];
    payload.filter = extendFilter(payload.filter, extend);
    payload.columns +=
      ',fixed_asset_category_id,life_time,depreciation_rate,org_price_account,depreciation_account,budget_chapter_code,budget_kind_item_code,budget_sub_kind_item_code,budget_item_code,budget_sub_item_code,grade,misa_code_id';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const fixedAssetCategoryComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã loại TSCĐ',
        dataField: 'fixed_asset_category_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên loại TSCĐ',
        dataField: 'fixed_asset_category_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 450,
      },
    ],
    displayField: 'fixed_asset_category_name',
    valueField: 'fixed_asset_category_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onFixedAssetCategoryComboboxLoadData,
  };

  // load combo TSCĐ detail
  const onFixedAssetCategoryDetailComboboxLoadData = (payload, row, column, custom) => {
    payload.sort = 'misa_code_id';
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let orsIsParent = [{Field: 'is_parent', Operator: proxy.$ms.constant.FilterOperator.Null}];
    let extend = [
      {Field: 'inactive', Value: false, Ors: ors},
      {Field: 'is_parent', Value: false, Ors: orsIsParent},
    ];
    payload.filter = extendFilter(payload.filter, extend);
    payload.columns +=
      ',fixed_asset_category_id,life_time,depreciation_rate,org_price_account,depreciation_account,budget_chapter_code,budget_kind_item_code,budget_sub_kind_item_code,budget_item_code,budget_sub_item_code,grade,misa_code_id';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo TSCĐ detail
  const fixedAssetCategoryDetailComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã loại TSCĐ',
        dataField: 'fixed_asset_category_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên loại TSCĐ',
        dataField: 'fixed_asset_category_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 450,
      },
    ],
    displayField: 'fixed_asset_category_name',
    valueField: 'fixed_asset_category_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onFixedAssetCategoryDetailComboboxLoadData,
  };

  return {
    fixedAssetCategoryComboConfig,
    fixedAssetCategoryDetailComboConfig,
    onFixedAssetCategoryComboboxLoadData,
    onFixedAssetCategoryDetailComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
